import { computed, type ComputedRef } from 'vue'
import { storeToRefs } from 'pinia'
import { useBrandStore } from '~/domain/shared/branding/stores/useBrandStore'
import { BrandName } from '~/domain/shared/branding/models/types'
import { BAGY_BRAND } from '~/domain/shared/branding/models/bagy'
import { TRAY_BRAND } from '~/domain/shared/branding/models/tray'
import { BagyPrimaryPalette } from '~/domain/shared/branding/presets/bagy'
import { CplugPrimaryPalette } from '~/domain/shared/branding/presets/cplug'
import { TrayPrimaryPalette } from '~/domain/shared/branding/presets/tray'
import { applyBrandPrimaryPalette } from '~/domain/shared/branding/utils/applyBrandPrimaryPalette'

const CPLUG_PRIMARY_COLOR = '#0091e6'

export interface UseBrandThemeReturn {
  apply: () => void
  brandName: ComputedRef<string>
  current: ComputedRef<BrandName>
  isBagy: ComputedRef<boolean>
  isTray: ComputedRef<boolean>
  primaryColor: ComputedRef<string>
}

export function useBrandTheme (): UseBrandThemeReturn {
  const store = useBrandStore()
  const { current, isBagy, isTray } = storeToRefs(store)

  const primaryColor = computed(() => {
    if (isBagy.value) {
      return BAGY_BRAND.primaryColor
    }
    if (isTray.value) {
      return TRAY_BRAND.primaryColor
    }
    return CPLUG_PRIMARY_COLOR
  })

  const brandName = computed(() => {
    if (isBagy.value) {
      return 'Bagy'
    }
    if (isTray.value) {
      return 'Tray'
    }
    return 'ConnectPlug'
  })

  function apply (): void {
    let palette = CplugPrimaryPalette

    if (isBagy.value) {
      palette = BagyPrimaryPalette
    } else if (isTray.value) {
      palette = TrayPrimaryPalette
    }

    applyBrandPrimaryPalette(palette)
    updateThemeColor(primaryColor.value)
  }

  function updateThemeColor (color: string): void {
    let meta = document.querySelector('meta[name="theme-color"]')

    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('name', 'theme-color')
      document.head.appendChild(meta)
    }

    meta.setAttribute('content', color)
  }

  return {
    apply,
    brandName,
    current,
    isBagy,
    isTray,
    primaryColor
  }
}
